import { login, getInfo, logout, postCode } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resolve } from "core-js/fn/promise";
import md5 from 'js-md5';
import { reject } from "lodash";
var user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false,
    team: {
      teamId: null,
      teamCode: "0000001",
      teamName: "一汽解放"
    }
  },
  mutations: {
    SET_TEAM: function SET_TEAM(state, team) {
      state.token = team;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER: function SET_USER(state, user) {
      state.user = user;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_LOAD_MENUS: function SET_LOAD_MENUS(state, loadMenus) {
      state.loadMenus = loadMenus;
    }
  },
  actions: {
    // 登录
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit;
      // const rememberMe = userInfo.rememberMe;
      return new Promise(function (resolve, reject) {
        // userInfo.username,
        // userInfo.password,
        console.log('md5===>', md5(userInfo.password));
        login({
          username: userInfo.username,
          password: md5(userInfo.password)
        }).then(function (res) {
          if (res.code === 200) {
            var token = "Bearer " + res.data.accessToken;
            setToken(token);
            commit("SET_TOKEN", token);
            setUserInfo(res.data.userInfo, commit);
            // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
            commit("SET_LOAD_MENUS", true);
            resolve();
          } else {
            reject(error);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 获取用户信息
    GetInfo: function GetInfo(_ref2) {
      var commit = _ref2.commit;
      return new Promise(function (resolve, reject) {
        getInfo().then(function (res) {
          setUserInfo(res.principal, commit);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 发送验证码
    PostCode: function PostCode(_ref3, mobile) {
      var commit = _ref3.commit;
      return new Promise(function (resolve, reject) {
        postCode(mobile).then(function (res) {
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 登出
    LogOut: function LogOut(_ref4) {
      var commit = _ref4.commit;
      return new Promise(function (resolve, reject) {
        logout().then(function (res) {
          logOut(commit);
          resolve();
        }).catch(function (error) {
          logOut(commit);
          reject(error);
        });
      });
    },
    updateLoadMenus: function updateLoadMenus(_ref5) {
      var commit = _ref5.commit;
      return new Promise(function (resolve, reject) {
        commit("SET_LOAD_MENUS", false);
      });
    },
    updateUserInfo: function updateUserInfo(_ref6, data) {
      var commit = _ref6.commit;
      return new Promise(function (resolve, reject) {
        setUserInfo(data, commit);
      });
    }
  }
};
export var logOut = function logOut(commit) {
  commit("SET_TOKEN", "");
  commit("SET_ROLES", []);
  removeToken();
};
export var setUserInfo = function setUserInfo(res, commit) {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.authorities.length === 0) {
    commit("SET_ROLES", ["ROLE_SYSTEM_DEFAULT"]);
  } else {
    commit("SET_ROLES", res.authorities);
  }
  commit("SET_USER", res);
};
export default user;